import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import ctaTypes from '../../../../../enums/CTA.enums';
import Icon from '../../../icon';
import { TArrowRight } from '../../types/cta.types';

const ArrowRight: FC<TArrowRight> = (props) => {
  const { type } = props;
  return (
    <div className="cta-arrow">
      <Icon iconName="arrow-simple-right" size={iconSize?.dsk} color={type === ctaTypes.secondaryRed ? 'primary' : 'white'} />
    </div>
  );
};

export default ArrowRight;
